'use strict';

const APIDefinition = require('../APIDefinition');

/**
 * A Device (e.g. smartphone) from an {@link AthomCloudAPI.User}.
 * @class
 * @hideconstructor
 * @memberof AthomCloudAPI
 */
class Device extends APIDefinition {

  /**
   * @type string
   */
  get id() {
    return this._id;
  }

}

module.exports = Device;
